<template>
  <div class="spinner-border align-items-start"
       style="font-size:10px;color:#9a9292;width:13px;height:13px;margin-right:2px">
    <span class="sr-only">Loading..</span>
  </div>
</template>
<script>
export default {
  name: 'spinner'
}
</script>
<style>

</style>